import { DisplayType as UserCalendarDisplayType } from 'domains/models/user_calendar/displayType';

export enum DisplayType {
  Private = 1,
  TeamPublic = 2,
  Public = 3,
}

export enum DisplayTypeText {
  Private = 'private',
  TeamPublic = 'teamPublic',
  Public = 'public',
}

export const toEventDisplayTypeFromIntegrationCalendar = (
  eventDisplayType: DisplayType,
  userCalendarDisplayType: UserCalendarDisplayType,
) => {
  if (eventDisplayType < userCalendarDisplayType) {
    return eventDisplayType;
  }
  return userCalendarDisplayType;
};
